import { useState, useEffect, useMemo } from "react";
import "./GradeWiseDetails.css";
import Phy from "../../../accerts/svg/emsat/Physics.svg";
import Chem from "../../../accerts/svg/emsat/Chemistry.svg";
import MAthIcon from "../../../accerts/svg/emsat/Mathametics.svg";
import zoo from "../../../accerts/svg/emsat/zoo.svg";
import botany from "../../../accerts/svg/emsat/botany.svg";
import Biology from "../../../accerts/svg/emsat/bio.svg";
import Logical from "../../../accerts/svg/emsat/logical.svg";
import Science from "../../../accerts/svg/emsat/science.svg";
import Critical from "../../../accerts/svg/emsat/critical.svg";
import Probelm from "../../../accerts/svg/emsat/problem.svg";
import ProgressBarChart from "./ProgressBarChart";
import target from "../../../accerts/svg/reportspage/target.svg";
import best from "../../../accerts/svg/reportspage/bestSub.svg";
import improve from "../../../accerts/svg/reportspage/improveSub.svg";
import Leaderboard from "./Leaderboard";
import blured from "../../../accerts/svg/Schoolreports/blured.png";
import Mwebblured from "../../../accerts/svg/Schoolreports/mblured.png";
import DropdownArrow from "../../../accerts/svg/Schoolreports/dropdown.svg";
import DropdownPortal from "./DropdownPortal";
import Separator from "../../../accerts/svg/Schoolreports/separator.svg";
import { motion, AnimatePresence } from "motion/react";
import useDropdownAnimation from "./useDropdownAnimation";
import ScrollContainer from "react-indiana-drag-scroll";
import { useHorizontalScroll } from "./useHorizontalScroll";
import { isValidData } from "../../../utils/validators";
import { DynamicToolTip } from "../DynamicToolTip/DynamicToolTip";
import i from "../../../accerts/svg/emsat/i.svg";

const BlurredBackgroundWithText = ({ text }) => (
  <div className="blurred-bg-container">
    <div
      className="blurred-bg web-blurred-bg"
      style={{ backgroundImage: `url(${blured})` }}
    >
      <div className="blurred-content">{text}</div>
    </div>
    <div
      className="blurred-bg mobile-blurred-bg"
      style={{ backgroundImage: `url(${Mwebblured})` }}
    >
      <div className="blurred-content">{text}</div>
    </div>
  </div>
);
const GradeWiseDetails = ({ data }) => {
  const allGrades = Array.from({ length: 13 }, (_, i) => `Grade-${i + 1}`);
  const availableGrades = useMemo(
    () => [...new Set(data.map((item) => item.grade))],
    [data]
  );

  const [selection, setSelection] = useState(() => {
    const firstAvailableGrade =
      availableGrades.length > 0 ? availableGrades[0] : "Grade-1";
    return {
      grade: firstAvailableGrade,
      exam: "JEE Mains",
    };
  });
  const {
    isOpen: isDropdownOpen,
    setIsOpen: setIsDropdownOpen,
    dropdownRef,
    dropdownAnimation,
  } = useDropdownAnimation();
  const [dropdownTarget, setDropdownTarget] = useState(null);
  const scrollRef = useHorizontalScroll();
  const [openTooltip, setOpenTooltip] = useState(null);

  const gradesWithExams = useMemo(() => {
    return data.reduce((acc, item) => {
      const { grade, exam_name } = item;
      if (!acc[grade]) {
        acc[grade] = [];
      }
      if (exam_name && !acc[grade].includes(exam_name)) {
        acc[grade].push(exam_name);
      }
      return acc;
    }, {});
  }, [data]);

  const handleGradeClick = (grade) => {
    const exams = gradesWithExams[grade] || [];
    let defaultExam = "JEE Mains";
    if (exams.length > 0 && !exams.includes("JEE Mains")) {
      defaultExam = exams[0];
    }
    setSelection({ grade, exam: defaultExam });
    setIsDropdownOpen(false);
  };

  const handleExamSelect = (grade, exam) => {
    setSelection({ grade, exam });
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    const exams = gradesWithExams[selection.grade] || [];
    if (!exams.includes(selection.exam)) {
      let defaultExam = "JEE Mains";
      if (exams.length > 0 && !exams.includes("JEE Mains")) {
        defaultExam = exams[0];
      }
      setSelection((prev) => ({ ...prev, exam: defaultExam }));
    }
    // Close tooltip when selection changes
    setOpenTooltip(null);
  }, [selection.grade, gradesWithExams, selection.exam]);

  // Close tooltip when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openTooltip) {
        const tooltipElement = event.target.closest(".more-tooltip");
        const tooltipBoxElement = event.target.closest(".tooltip-box");
        if (!tooltipElement && !tooltipBoxElement) {
          setOpenTooltip(null);
        }
      }
    };

    if (openTooltip) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openTooltip]);

  const selectedGradeData = data.find((item) => {
    const gradeMatches = item.grade === selection.grade;
    const examMatches = !item.exam_name || item.exam_name === selection.exam;
    return gradeMatches && examMatches;
  });

  const subjects = selectedGradeData?.subjects
    ? Object.entries(selectedGradeData.subjects)
    : [];
  const validSubjects = subjects.filter(
    ([subjectName]) => subjectName !== "null" && subjectName
  );
  const hasValidSubjects = validSubjects.length > 0;

  const getImage = (subject) => {
    switch (subject) {
      case "Physics":
        return Phy;
      case "Chemistry":
        return Chem;
      case "Mathematics":
        return MAthIcon;
      case "Botany":
        return botany;
      case "Zoology":
        return zoo;
      case "Biology":
        return Biology;
      case "Science":
        return Science;
      case "Critical Thinking":
        return Critical;
      case "Logical Reasoning":
        return Logical;
      case "Problem Solving":
        return Probelm;
      case "HOTS":
        return Critical;
      default:
        return Probelm;
    }
  };

  const getDisplayName = (exam) => {
    if (exam === "JEE Mains") {
      return "JEE";
    }
    return exam;
  };

  return (
    <div className="grade-container">
      <div className="sticky-header">
        <div className="tabs-container">
          <ScrollContainer
            className="tabs-scroll"
            vertical={false}
            innerRef={scrollRef}
          >
            {allGrades.map((grade) => {
              const gradeNumber = parseInt(grade.split("-")[1], 10);
              const examsForGrade = gradesWithExams[grade] || [];
              const isAvailable = availableGrades.includes(grade);
              const isActive = selection.grade === grade;
              // Only show exams dropdown for grades 9 and above
              const showDropdown =
                isAvailable && examsForGrade.length > 1 && gradeNumber >= 9;
              const showSingleExam =
                isAvailable && examsForGrade.length === 1 && gradeNumber >= 9;

              return (
                <div key={grade} className="grade-tab-wrapper">
                  <motion.button
                    onClick={() => handleGradeClick(grade)}
                    className={`grade-tab ${isActive ? "active" : ""}`}
                    whileTap={!isActive ? { scale: 0.9 } : {}}
                    transition={{ duration: 0.1 }}
                  >
                    {grade}
                    {showSingleExam && isActive && (
                      <>
                        <img src={Separator} alt="|" className="separator" />
                        <span className="exam-single">
                          {getDisplayName(examsForGrade[0])}
                        </span>
                      </>
                    )}
                    {showDropdown && isActive && (
                      <>
                        <img src={Separator} alt="|" className="separator" />
                        <span
                          ref={dropdownRef}
                          className="exam-selector"
                          onClick={(e) => {
                            e.stopPropagation();
                            setDropdownTarget(e.currentTarget);
                            setIsDropdownOpen(!isDropdownOpen);
                          }}
                        >
                          {getDisplayName(selection.exam)}{" "}
                          <motion.img
                            src={DropdownArrow}
                            alt="v"
                            animate={{ rotate: isDropdownOpen ? 180 : 0 }}
                            transition={{
                              type: "spring",
                              stiffness: 500,
                              damping: 30,
                            }}
                          />
                        </span>
                      </>
                    )}
                  </motion.button>
                  <AnimatePresence>
                    {showDropdown && isActive && isDropdownOpen && (
                      <DropdownPortal targetElement={dropdownTarget}>
                        <motion.div
                          className="exam-dropdown"
                          {...dropdownAnimation}
                        >
                          {examsForGrade.map((exam) => (
                            <div
                              key={exam}
                              className="exam-option"
                              onClick={() =>
                                handleExamSelect(selection.grade, exam)
                              }
                            >
                              {getDisplayName(exam)}
                            </div>
                          ))}
                        </motion.div>
                      </DropdownPortal>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </ScrollContainer>
        </div>
      </div>

      <div className="grade-content">
        <AnimatePresence mode="wait">
          <motion.div
            key={`${selection.grade}-${selection.exam}`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            {selectedGradeData ? (
              <>
                {hasValidSubjects ? (
                  validSubjects.map(([subjectName, subjectData]) => (
                    <div key={subjectName} className="SHRep_Sub_cont">
                      <p
                        className="SCHsubjectwise-name"
                        style={{ fontSize: "18px", fontWeight: "600" }}
                      >
                        <span>
                          <img src={getImage(subjectName)} alt={subjectName} />
                        </span>
                        {subjectName}
                      </p>
                      <div className="SCHdetaileCont">
                        <ProgressBarChart
                          totalMarks={subjectData.total_marks}
                          benchmarkPercentage={parseFloat(
                            subjectData.other_school_avg
                          )}
                          barsData={{
                            max_marks: subjectData.max_marks,
                            avg_marks: subjectData.avg_marks,
                          }}
                          subjectName={subjectName}
                          showBenchmark={false}
                        />
                        <div className="SCHdetaileinnerCont">
                          <h4 className="chart_title">
                            Subject Accuracy{" "}
                            <DynamicToolTip
                              content={`Accuracy refers to the percentage of correctly answered questions out of the total attempted. This data shows the average accuracy of Grade ${selection.grade.replace(
                                "Grade-",
                                ""
                              )} students in ${subjectName}.`}
                            >
                              <span>
                                {" "}
                                <img className="EMRe_info" src={i} alt="i" />
                              </span>
                            </DynamicToolTip>
                          </h4>
                          <div className="SCHdetailecard">
                            <h3 className="SCHcardInto">
                              <span>
                                <img src={target} alt="percentage icon" />
                              </span>
                              Accuracy
                            </h3>
                            <h4 className="SCHcardIntoValue">
                              {subjectData.accuracy || "0.0%"}
                            </h4>
                          </div>
                          {isValidData(subjectData?.best_chapters) &&
                            isValidData(subjectData?.improvement_chapters) && (
                              <h4 className="chart_title">
                                Chapter level Performance{" "}
                                <DynamicToolTip
                                  content={`This section highlights the chapters where the grade has performed well, as well as those where performance was lower.`}
                                >
                                  <span>
                                    {" "}
                                    <img
                                      className="EMRe_info"
                                      src={i}
                                      alt="i"
                                    />
                                  </span>
                                </DynamicToolTip>
                              </h4>
                            )}
                          {isValidData(subjectData?.best_chapters) &&
                            isValidData(subjectData?.improvement_chapters) && (
                              <div className="chart_title_show">
                                {isValidData(subjectData?.best_chapters) && (
                                  <div className="SCHrow">
                                    <h3 className="SCHcardInto">
                                      <span>
                                        <img src={best} alt="Best chapter" />
                                      </span>
                                      Best chapter
                                    </h3>
                                    <h4 className="SCHcardIntoValue">
                                      {subjectData.best_chapters
                                        ?.slice(0, 2)
                                        .join(", ") || "N/A"}
                                      {subjectData.best_chapters?.length >
                                        2 && (
                                        <span
                                          className={`more-tooltip ${
                                            openTooltip ===
                                            `best-${subjectName}`
                                              ? "active"
                                              : ""
                                          }`}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            const tooltipId = `best-${subjectName}`;
                                            setOpenTooltip(
                                              openTooltip === tooltipId
                                                ? null
                                                : tooltipId
                                            );
                                          }}
                                        >
                                          <span className="more-text">
                                            , more
                                          </span>
                                          <div className="tooltip-box">
                                            <ul className="tooltip-list">
                                              {subjectData.best_chapters.map(
                                                (chapter, index) => (
                                                  <li key={index}>{chapter}</li>
                                                )
                                              )}
                                            </ul>
                                          </div>
                                        </span>
                                      )}
                                    </h4>
                                  </div>
                                )}
                                {isValidData(
                                  subjectData?.improvement_chapters
                                ) && (
                                  <div className="SCHrow">
                                    <h3 className="SCHcardInto">
                                      <span>
                                        <img
                                          src={improve}
                                          alt="Scope of improvement"
                                        />
                                      </span>
                                      Scope of improvement
                                    </h3>
                                    <h4 className="SCHcardIntoValue">
                                      {subjectData.improvement_chapters
                                        ?.slice(0, 2)
                                        .join(", ") || "N/A"}
                                      {subjectData.improvement_chapters
                                        ?.length > 2 && (
                                        <span
                                          className={`more-tooltip ${
                                            openTooltip ===
                                            `improvement-${subjectName}`
                                              ? "active"
                                              : ""
                                          }`}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            const tooltipId = `improvement-${subjectName}`;
                                            setOpenTooltip(
                                              openTooltip === tooltipId
                                                ? null
                                                : tooltipId
                                            );
                                          }}
                                        >
                                          <span className="more-text">
                                            , more
                                          </span>
                                          <div className="tooltip-box">
                                            <ul className="tooltip-list">
                                              {subjectData.improvement_chapters.map(
                                                (chapter, index) => (
                                                  <li key={index}>{chapter}</li>
                                                )
                                              )}
                                            </ul>
                                          </div>
                                        </span>
                                      )}
                                    </h4>
                                  </div>
                                )}
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <BlurredBackgroundWithText
                    text={`There was no participation from ${selection.grade}`}
                  />
                )}

                <div style={{ marginTop: "30px" }}>
                  <h3>
                    Student Details{" "}
                    <DynamicToolTip
                      content={`This section lists all students from this grade, showing who participated in the test and who missed it.`}
                    >
                      <span>
                        {" "}
                        <img className="EMRe_info" src={i} alt="i" />
                      </span>
                    </DynamicToolTip>
                  </h3>
                  {selectedGradeData.student_performance ? (
                    <Leaderboard
                      key={`${selection.grade}-${selection.exam}-leaderboard`}
                      students={
                        selectedGradeData.student_performance.attempted || []
                      }
                      notAttempted={
                        selectedGradeData.student_performance.not_attempted ||
                        []
                      }
                    />
                  ) : (
                    <div className="no-data-message">
                      No registrations were received from {selection.grade}
                    </div>
                  )}
                </div>
              </>
            ) : (
              <BlurredBackgroundWithText
                text={`No registrations were received from ${selection.grade}`}
              />
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default GradeWiseDetails;
